import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { DashboardLayout } from './components/layout/DashboardLayout';
import { SignInPage } from './pages/auth/SignInPage';
import { DashboardPage } from './pages/dashboard/DashboardPage';
import { LeadsPage } from './pages/leads/LeadsPage';
import { LeadDetailsPage } from './pages/leads/LeadDetailsPage';
import { CompaniesPage } from './pages/companies/CompaniesPage';
import { CompanyDetailsPage } from './pages/companies/CompanyDetailsPage';
import { ContactsPage } from './pages/contacts/ContactsPage';
import { ContactDetailsPage } from './pages/contacts/ContactDetailsPage';
import { DealsPage } from './pages/deals/DealsPage';
import { DealDetailsPage } from './pages/deals/DealDetailsPage';
import { PipelinePage } from './pages/deals/PipelinePage';
import { ActivitiesPage } from './pages/activities/ActivitiesPage';
import { SettingsPage } from './pages/settings/SettingsPage';
import { useAuthStore } from './store/authStore';
import { supabase } from './lib/supabase/client';

function App() {
  const { user, isLoading, initialized, refreshUser } = useAuthStore();

  useEffect(() => {
    refreshUser();

    const { data: authListener } = supabase.auth.onAuthStateChange(() => {
      setTimeout(async () => {
        await refreshUser();
      }, 100);
    });

    return () => {
      authListener?.subscription.unsubscribe();
    };
  }, [refreshUser]);

  if (!initialized && isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-primary"></div>
      </div>
    );
  }

  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        {user ? (
          <>
            <Route path="/*" element={<DashboardLayout />}>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<DashboardPage />} />
              
              {/* Leads */}
              <Route path="leads" element={<LeadsPage />} />
              <Route path="leads/:id" element={<LeadDetailsPage />} />
              
              {/* Companies */}
              <Route path="companies" element={<CompaniesPage />} />
              <Route path="companies/:id" element={<CompanyDetailsPage />} />
              
              {/* Contacts */}
              <Route path="contacts" element={<ContactsPage />} />
              <Route path="contacts/:id" element={<ContactDetailsPage />} />
              
              {/* Deals */}
              <Route path="deals" element={<DealsPage />} />
              <Route path="deals/pipeline" element={<PipelinePage />} />
              <Route path="deals/:id" element={<DealDetailsPage />} />
              
              {/* Activities */}
              <Route path="activities" element={<ActivitiesPage />} />
              
              {/* Settings */}
              <Route path="settings" element={<SettingsPage />} />
              
              {/* Catch all */}
              <Route path="*" element={<Navigate to="dashboard" replace />} />
            </Route>
          </>
        ) : (
          <>
            <Route path="/login" element={<SignInPage />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
